import axios from 'axios';
// キャッシュはページ内メモリに限定する。再読み込み時にサーバーから平文トークンは復元しない。
const handoffs = new Map();
export default function getAppPracticeHandoff(examinationId, subjectId) {
    const key = `${examinationId}:${subjectId}`;
    const cached = handoffs.get(key);
    // 発行中のPromiseも共有し、QR準備とクリックが重なった際の重複発行を防ぐ。
    if (cached && (!cached.expiresAt || cached.expiresAt > Date.now()))
        return cached.promise;
    const entry = {
        expiresAt: null,
        promise: axios.post(route('app-practice.store'), {
            examination_id: examinationId,
            subject_id: subjectId,
        }).then(({ data }) => {
            const expiresAt = Date.parse(data.expires_at);
            const url = new URL(data.url);
            if (url.protocol !== 'https:' || !Number.isFinite(expiresAt) || expiresAt <= Date.now()) {
                throw new Error('Invalid handoff response');
            }
            entry.expiresAt = expiresAt;
            return data;
        }).catch(error => {
            // 失敗した結果は保持せず、次の操作で再発行を試みられるようにする。
            if (handoffs.get(key) === entry)
                handoffs.delete(key);
            throw error;
        }),
    };
    handoffs.set(key, entry);
    return entry.promise;
}
// トークンを再発行せず、押されたボタンに対応するストア転送先だけを付ける。
export function buildAppPracticeUrl(baseUrl, platform) {
    const url = new URL(baseUrl);
    url.searchParams.set('platform', platform);
    return url.toString();
}
export function clearAppPracticeHandoff(examinationId, subjectId) {
    handoffs.delete(`${examinationId}:${subjectId}`);
}
export async function isAppPracticeHandoffAvailable(url) {
    const token = new URL(url).pathname.split('/').pop();
    const response = await axios.post(route('app-practice.status'), { handoff_token: token });
    return response.data.available;
}
